import { render, staticRenderFns } from "./CmsIndexDetails.vue?vue&type=template&id=6d697c1c&scoped=true"
import script from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
export * from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
import style0 from "./CmsIndexDetails.vue?vue&type=style&index=0&id=6d697c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d697c1c",
  null
  
)

export default component.exports